/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	function trackKeymatchClick(mod, keymatch, config) {
		// Store URL so the referenced page knows where we came from
		if ('localStorage' in window) {
			window.localStorage.setItem('sitesearch-keymatch-origin-url', window.location.href);
		}
		// Tracking
		Module.SearchResultContainer.trackClick('keymatch', config, keymatch, mod.searchProcessor);
	}


	var SearchTopResults = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving keymatches
		searchProcessor: null,
		// The DOM/vDOM element for displaying keymatches
		contentsContainer: null,
		// Search result display modules. These should filter out results if they point to the same URL as the keymatches we display
		searchDisplayModules: [],

		on: function(callback) {
			callback();
		},

		after: function() {
			this.contentsContainer = this.$ctx.find('> .contents')[0];
			this.translations = {
				detailsText: this.$ctx.attr('data-details-text'),
				ratingCount: this.$ctx.attr('data-sitesearch-numberOfReviews')
			};
		},

		initSearch: function(searchContainer) {
			var mod = this;
			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}
			mod.searchDisplayModules = searchContainer.internalModulesByName('SearchResultDisplay');
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forKeymatches(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$config.attr('data-sitesearch-gsainstantsearchresults'),
				$('html').attr('lang') || 'de',
				mod.$ctx.attr('data-sitesearch-instantsearchcollectionsuffix')
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.keymatchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		keymatchData: function(processor, data, config) {
			var mod = this;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var keymatch, i;

			var keymatches = $.grep(config.keymatches || [], function(el) {
				return !el.error;
			});

			if(mod.searchDisplayModules.length) {
				var keymatchURLs = {};
				for(i=0;i<keymatches.length;i+=1) {
					keymatch = keymatches[i];
					keymatchURLs[Module.SearchResultDisplay.normalizeURL(keymatch.url)] = true;
				}
				for(i=0;i<mod.searchDisplayModules.length;i+=1) {
					mod.searchDisplayModules[i].dataUpdated(null, keymatchURLs);
				}
			}
			var hasKeymatches = keymatches.length > 0;
			mod.$ctx.toggleClass('active', hasKeymatches);

			var keymatchElements = [];
			for(i=0;i<keymatches.length;i+=1) {
				keymatch = keymatches[i];
				var display = keymatch.display;
				display = 'render' + display[0].toUpperCase()+display.substring(1).toLowerCase() + 'Keymatch';
				if(!(display in mod)) {
					display = 'renderGenericKeymatch';
				}
				var vnode = mod[display](keymatch, h, config);
				if(vnode) {
					keymatchElements.push(vnode);
				}
			}

			mod.contentsContainer = snabbdom.patch(mod.contentsContainer, h('div', keymatchElements));

		},

		renderGenericKeymatch: function(keymatch, h, config) {
			return h(
				'div.scs-sitesearch-keymatch.scs-sitesearch-selfcare.scs-sitesearch-'+keymatch.display,
				[
					h('div.scs-sitesearch-'+keymatch.display+'-tag'),
					h(
						'div.scs-sitesearch-selfcare-box',
						[h(
							'a',
							{
								props: {
									href: keymatch.url
								},
								on: {
									click: [trackKeymatchClick, this, keymatch, config]
								}
							},
							[
								h(
									'div.scs-sitesearch-selfcare-title',
									[keymatch.title]
								)
							]
						), h(
							'div.scs-sitesearch-selfcare-box-text',
							[keymatch.subtitle]
						)]
					)
				]
			);
		},

		// Don’t display webcodes
		renderWebcodeKeymatch: function() {
			return null;
		},

		renderProductKeymatch: function(keymatch, h, config) {
			var image = [];
			if(keymatch.image) {
				image = [h(
					'img',
					{
						props: {
							src: keymatch.image
						}
					}
				)];
			}
			var rating = h('div');
			if(typeof keymatch.rating === 'number' && keymatch.ratingCount > 0) {
				rating = h(
					'div.scs-sitesearch-product-teaser-rating',
					[
						h('div.scs-sitesearch-product-teaser-stars', {
							attrs: {
								'data-rating': keymatch.rating
							}
						}),
						h('div.scs-sitesearch-rating-txt', [
							SCS.utils.formatString(
								this.translations.ratingCount,
								keymatch.ratingCount
							)
						])
					]
				);
			}
			return h(
				'div.scs-sitesearch-product-teaser',
				[
					h(
						'div.scs-sitesearch-product-teaser-image',
						{
							'class': {
								'default-product': !keymatch.image
							}
						},
						image
					),
					h(
						'div.scs-sitesearch-product-teaser-content',
						[
							h(
								'a',
								{
									props: {
										href: keymatch.url
									},
									on: {
										click: [trackKeymatchClick, this, keymatch, config]
									}
								}, 
								[
									h('div.scs-sitesearch-product-teaser-title', 
										[keymatch.title]
									)
								]
							),
							h('div.scs-sitesearch-product-teaser-intro', [keymatch.subtitle]),
							rating,
							h('div.scs-sitesearch-clear'),
							h(
								'div.scs-sitesearch-product-teaser-details',
								[
									h('div.scs-sitesearch-details-txt', [this.translations.detailsText])
								]
							)
						]
					)
				]
				
			);
		}

	});

	Module.SearchTopResults = SearchTopResults;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchTopResults.js
// module id = 66
// module chunks = 0